module.exports = __webpack_public_path__ + "a1fcec9b39af30912fe37938892bdf8c.jpg";